// Partnered Ecosystem — three fractional specialties.
// Brand-faithful tints that live alongside the PMG navy palette.
export const ECO_TINTS = {
    navy:     { bg: "#EEF1F6", soft: "#F4F6F9", line: "#D8DEE7", ink: "#182553", deep: "#0F1A40" },
    indigo:   { bg: "#ECEDF3", soft: "#F3F4F8", line: "#D4D6E0", ink: "#2A2F5C", deep: "#1A1F44" },
    graphite: { bg: "#EAECEE", soft: "#F2F4F5", line: "#D2D6DA", ink: "#2B3640", deep: "#1A2128" },
};

export const ECOSYSTEM = [
    {
        id: "fpm",
        number: "01",
        icon: "pm",
        title: "Fractional PM",
        tagline: "A PMP-certified project manager embedded with your team without the full-time overhead.",
        longTagline: "Get senior project leadership exactly when you need it. Our Project Managers take ownership of your most critical work and hand off cleanly when you're ready.",
        tintKey: "navy",
        label: "Delivery rhythm",
        bullets: [
            "PMP-certified leadership, 10–30 hrs / week",
            "Owns delivery from kickoff to close",
            "Stakeholder communication & status",
            "Risk, budget, and scope management",
        ],
        forWho: [
            "Growing teams without a dedicated PM bench",
            "Critical initiatives that can't wait for hiring",
            "Companies bridging a PM transition",
            "Agencies where the workload has outgrown the team"
        ]
    },
    {
        id: "fops",
        number: "02",
        icon: "ops",
        title: "Fractional Operations",
        tagline: "Senior operations leadership that builds the systems your business runs on.",
        longTagline: "We sort out the processes, the tools, and the workflows so your team can focus on what they are actually good at.",
        tintKey: "indigo",
        label: "Operating model",
        bullets: [
            "Operating modeldesign",
            "SOP development",
            "AI workflow integration and utilization", 
            "KPI development and reporting frameworks",
            "Financial performance analysis",
        ],
        forWho: [
            "Companies hitting a growth ceiling",
            "Founders who are ready to hand off the back office",
            "Teams buried in tools and tickets with no clear system underneath",
           "Businesses that know something is broken but cannot pinpoint what"
        ]
    },
    {
        id: "fdd",
        number: "03",
        icon: "design",
        title: "Fractional Design & Development",
        tagline: "A design-led product team to ship what your roadmap is waiting on.",
        longTagline: "Senior designers and engineers who embed into your team and start executing. Whether it is brand, internal tools, or a customer facing product, we bring the talent without the full time overhead.",
        tintKey: "graphite",
        label: "Shipped product",
        bullets: [
            "Brand and product design",
            "Front-end and full-stack engineering",
            "Design ops and component systems",
            "Rapid prototyping & MVPs",
        ],
        forWho: [
            "Teams without an in-house design or engineering team",
            "Stalled internal or client projects needing progress",
            "Anyone shipping their first product version",
        ]
    },
];

// "How an engagement starts" — four stages.
export const ENGAGE_STAGES = [
    { n: "01", t: "Discovery", d: "A 30-minute call where we dig into your pain points." },
    { n: "02", t: "Match",     d: "We match you with the right person on our team based on skillset and culture fit." },
    { n: "03", t: "Embed",     d: "Your practitioner is embedded within 24 to 48 hours." },
    { n: "04", t: "Deliver",   d: "Your practitioner executes week over week. You see measurable progress." },
];
